var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneCircle = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#00338E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7575 14.535C17.835 14.535 16.9425 14.385 16.11 14.115C15.8475 14.025 15.555 14.0925 15.3525 14.295L14.175 15.7725C12.0525 14.76 10.065 12.8475 9.0075 10.65L10.47 9.405C10.6725 9.195 10.7325 8.9025 10.65 8.64C10.3725 7.8075 10.23 6.915 10.23 5.9925C10.23 5.5875 9.8925 5.25 9.4875 5.25H6.8925C6.4875 5.25 6 5.43 6 5.9925C6 12.96 11.7975 18.75 18.7575 18.75C19.29 18.75 19.5 18.2775 19.5 17.865V15.2775C19.5 14.8725 19.1625 14.535 18.7575 14.535Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone_circle.93f0dbf9db3e5de1927882e8d17324f1.svg";